import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/Wendy_Pet/subs.vtt';
import poster from '@/static/assets/reviews/Wendy_Pet/video.jpg';

export const Wendy: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Pet, ReviewProduct.All],
  reviewerName: 'Wendy',
  videoUrl: `${ASSETS_URL}/pet/Wendy_pet.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
